import { useEffect, useState } from 'react';
import { api } from '../../lib/api';
import { DashboardGrid } from './DashboardGrid';
import { LoadingSpinner } from '../Common/LoadingSpinner';
import { showToast } from '../../hooks/useToast';

export function PersonalDashboard() {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.getDashboards().then(setData).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  if (loading) return <LoadingSpinner label="Loading dashboard…" />;
  if (!data?.personal) return <div className="text-sm text-text-muted">No personal dashboard yet. Save a report to start adding widgets.</div>;

  const widgets = data.personal.widgets ?? [];

  return (
    <div className="space-y-3">
      <div className="text-xs text-text-muted">{widgets.length} widget{widgets.length === 1 ? '' : 's'}</div>
      <DashboardGrid
        widgets={widgets}
        onRemove={async (widgetId) => {
          try {
            await api.removeWidget(data.personal.id, widgetId);
            showToast('success', 'Widget removed');
            load();
          } catch (err: any) {
            showToast('error', err.message ?? 'Remove failed');
          }
        }}
      />
    </div>
  );
}
